import { call } from '../../utils/serviceUtils';
import {
  NOTIFICATION_GET,
  NOTIFICATION
  } from '../../config/paths';


export function getNotifications() {
  return call.get(NOTIFICATION_GET,
    {

    });
}

export function deleteNotificationById(id) {
  return call.delete(NOTIFICATION+'/'+id,
  {
    
  });
}

export function createNotification(data) {
  return call.post(NOTIFICATION,data);
}

export function updateNotification(id,data) {
  return call.put(NOTIFICATION+'/'+id,data);
}


